<app-navbar />
<main class="min-h-screen pt-16 ">
  @defer {
  <p-toast></p-toast>
  }
  <router-outlet></router-outlet>
</main>
@defer (on viewport; prefetch on idle) {
<app-footer />
} @placeholder {
<div class="h-52"></div>
}